module.exports = __webpack_public_path__ + "img/demo1.bf0af3ce.png";